import React, { useEffect, useState } from 'react';
import { ConsentManager } from '@segment/consent-manager';

// Segment's cookie banner. Segment (and the destinations it loads, like GTM) only runs once the
// visitor allows it. The choice is saved in the `tracking-preferences` cookie on .particle.io.
// The banner only shows when the Segment source has at least one destination.
export default function CookieBanner() {
  // Set by gatsby-plugin-segment-js. Read after mounting, as the banner isn't in the static HTML
  const [writeKey, setWriteKey] = useState(null);
  useEffect(() => setWriteKey(window.analytics && window.analytics._writeKey), []);
  if (!writeKey) {
    return null;
  }

  return (
    <div style={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 999999 }}>
      <ConsentManager
        writeKey={writeKey}
        shouldRequireConsent={() => true}
        bannerContent={
          <span>
            We use cookies (and other similar technologies) to collect data to improve your experience on
            our site. By using our website, you’re agreeing to the collection of data as described in our{' '}
            <a href="https://www.particle.io/legal/privacy/">Website Data Collection Policy</a>.
          </span>
        }
        bannerSubContent="You can change your preferences at any time."
        bannerActionsBlock
        bannerBackgroundColor="#00334F"
      />
    </div>
  );
}
